module.exports = __webpack_public_path__ + "static/image_qsehra-4e409e20097c2fb86c87481ef38f190f.jpg";